export default "__VITE_ASSET__d3ac2795__"